export const SHOW_PANEL = 'SHOW_PANEL';
export const FULL_MODAL_OPEN = 'FULL_MODAL_OPEN';
export const SCREEN_SIZE = 'SCREEN_SIZE';
export const TOGGLE_CONTEXT_MENU = 'TOGGLE_CONTEXT_MENU';
export const FULL_SCREEN_MODAL_OPEN = 'FULL_SCREEN_MODAL_OPEN';